import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "@/features/utils/i18n";
import { SortDescendingIcon } from "@phosphor-icons/react";

/**
 * One menu both orders the list and groups it: by urgency (each group by
 * deadline), or by date, most recent first, under Today / Yesterday / This week
 * / month.
 */
export type MessageSort = "urgency" | "recent";

export const SORTS: MessageSort[] = ["urgency", "recent"];

export const SortMenu = ({
  value,
  onChange,
}: {
  value: MessageSort;
  onChange: (value: MessageSort) => void;
}) => {
  const { t } = useTranslation("messages");
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          className="h-7 gap-1 px-2 text-xs text-muted-foreground"
        >
          <SortDescendingIcon className="size-3.5" />
          {t(`sort.${value}`)}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup
          value={value}
          onValueChange={(v) => onChange(v as MessageSort)}
        >
          {SORTS.map((sort) => (
            <DropdownMenuRadioItem key={sort} value={sort}>
              {t(`sort.${sort}`)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
